import { render } from "./GuardianPanel.vue?vue&type=template&id=df709bb0&scoped=true"
import script from "./GuardianPanel.vue?vue&type=script&lang=js"
export * from "./GuardianPanel.vue?vue&type=script&lang=js"

import "./GuardianPanel.vue?vue&type=style&index=0&id=df709bb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df709bb0"]])

export default __exports__